import { render, staticRenderFns } from "./PendingIcon.vue?vue&type=template&id=b0ed00ae&"
import script from "./PendingIcon.vue?vue&type=script&lang=js&"
export * from "./PendingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports